module.exports = __webpack_public_path__ + "static/media/speaker2.cc746906.jpg";